import React, { useContext, useEffect, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    useToast,
    Input,
    Spinner,
  } from '@chakra-ui/react'
  import { CiEdit } from "react-icons/ci";

import { BiExit } from 'react-icons/bi';
import { AuthContext } from '../../../context/auth';
import axios from 'axios';
import { getuseruri, user_uri } from '../../../uri';

const EditModal = ({data, callback}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {currentUser} = useContext(AuthContext);
    const toast = useToast();
    const [load, setLoad] = useState(false);
    const [datas, setDatas] = useState({username:"", phone_no:"", token: currentUser});

    useEffect(() => {
      setDatas({...datas, username: data.username, phone_no: data.phone_no});
    }, [data]);

      const handlecall = () => {
        callback();
      }
    
      const Submit = async () =>{
        setLoad(true);
        try{
            const res = await axios.patch(getuseruri+"/updateinfo", {username: datas.username, phone_no: datas.phone_no, token: currentUser});
            if(res.status === 200){
                toast({title: 'Амжилттай',description: "Таны мэдээлэл шинэчлэгдлээ",status: 'success',duration: 5000,isClosable: true,});
                handlecall();
            }
            if(res.status === 204){
              toast({title: 'Анхаар',description: "Энэ дугаар бүртгэлтэй байна",status: 'warning',duration: 5000,isClosable: true,});
            }
            setLoad(false);
        }catch(err){
            console.log(err);
            setLoad(false);
        }
      }


  return (
    <>
        <div onClick={onOpen}className='flex font-bold items-center gap-2 bg-gray-100 cursor-pointer text-gray-800 mt-2 p-2 rounded-xl w-60 justify-center '>
            <CiEdit size={24}/>
            <h1 className='text-xs'>Өөрийн мэдээлэл засварлах</h1>
        </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Өөрийн мэдээлэл засварлах</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className='font-Roboto text-sm'>
                <h1 className='mt-2'>Хэрэглэгчийн нэр *</h1>
                <Input className='mt-1' value={datas.username} onChange={(e) => setDatas({...data, username: e.target.value})}/>
                <h1 className='mt-2'>Утасны дугаар *</h1>
                <Input className='mt-1' value={datas.phone_no} onChange={(e) => setDatas({...data, phone_no: e.target.value})}/>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Болих
            </Button>
            {
                load ?
                <Button variant='ghost'><Spinner color='blue'/></Button>
                :
                <Button onClick={Submit} variant='ghost'>Хадгалах</Button>
            }
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default EditModal